<template>
    <div class="skeleton-line" :class="{dark, link}" :style="style"></div>
</template>

<script>
export default {
    name: 'Skeleton',
    props: {
        width: String,
        height: { type: String, default: '17px' },
        dark: { type: Boolean, default: false },
        link: { type: Boolean, default: false },
    },
    computed: {
        style() {
            return {
                width: this.width,
                height: this.height,
            };
        },
    },
};
</script>

<style scoped>
    .skeleton-line {
        border-radius: 3px;
        background-size: 600px;
        animation: shine-lines 1.5s infinite ease-out;
        background-image: linear-gradient(90deg, #d0d0d0 0px, #fff 40px, #d0d0d0 100px);
    }
    .dark {
        background-image: linear-gradient(90deg, #a4a4a4 0px, #fff 40px, #a4a4a4 100px);
    }
    .link {
        background-image: linear-gradient(90deg, #93b9f5 0px, #fff 40px, #93b9f5 100px);
    }
    @keyframes shine-lines {
        0% {background-position: -100px;}
        40%, 100% {background-position: 220px;}
    }
</style>
